module.exports = __webpack_public_path__ + "1d10c6760d0baeab1d18955ad66ed628.png";